/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wise_Swift_Mole_SoarInputs */

const en_wise_swift_mole_soar = /** @type {(inputs: Wise_Swift_Mole_SoarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Participation deleted`)
};

const de_wise_swift_mole_soar = /** @type {(inputs: Wise_Swift_Mole_SoarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teilnahme gelöscht`)
};

/**
* | output |
* | --- |
* | "Participation deleted" |
*
* @param {Wise_Swift_Mole_SoarInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const wise_swift_mole_soar = /** @type {((inputs?: Wise_Swift_Mole_SoarInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wise_Swift_Mole_SoarInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_wise_swift_mole_soar(inputs)
	return de_wise_swift_mole_soar(inputs)
});